import React, { Component } from "react";
import FAQList from "./faqList";

export default class FAQ extends Component {
  render() {
    return (
      <div id="FAQ">
        <section className="FAQ" data-section="FAQ">
          <div></div>
          <div className="media col-md-12 text-center">
            <a
              href="https://play.google.com/store/apps/details?id=com.doublethefun.rumba"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/images/rumba/icon.png"
                alt="Rumba - Ballroom Dancing"
                height="200"
                width="200"
              />
            </a>
            <h1 className="heading">Frequently Asked Questions</h1>
          </div>
          <div>
            <FAQList />
          </div>
        </section>
      </div>
    );
  }
}
